// ContactoAsociado.js - Teléfono, correo y sitio web de un club/gimnasio (solo los que existan)
import React from 'react';

const pStyle = { color: '#555', fontSize: '0.9em', margin: '5px 0', overflowWrap: 'anywhere' };
const aStyle = { color: 'inherit', textDecoration: 'underline', textUnderlineOffset: '2px' };

const ContactoAsociado = ({ asociado, conEtiquetas = false }) => {
  const tel = (asociado.telefono || '').trim();
  const mail = (asociado.email || '').trim();
  const web = (asociado.sitio_web || '').trim();
  const webUrl = web && !/^https?:\/\//i.test(web) ? `https://${web}` : web;

  if (!tel && !mail && !web) {
    return <p style={{ ...pStyle, fontStyle: 'italic' }}>Sin datos de contacto</p>;
  }
  const etiqueta = (icono, texto) => <strong>{conEtiquetas ? `${texto}:` : icono}</strong>;

  return (
    <>
      {tel && (
        <p style={pStyle}>
          {etiqueta('📞', 'Teléfono')} <a href={`tel:${tel.replace(/[^\d+]/g, '')}`} style={aStyle}>{tel}</a>
        </p>
      )}
      {mail && (
        <p style={pStyle}>
          {etiqueta('✉️', 'Email')} <a href={`mailto:${mail}`} style={aStyle}>{mail}</a>
        </p>
      )}
      {web && (
        <p style={pStyle}>
          {etiqueta('🌐', 'Web')}{' '}
          <a href={webUrl} target="_blank" rel="noopener noreferrer" style={aStyle}>
            {web.replace(/^https?:\/\//i, '').replace(/\/$/, '')}
          </a>
        </p>
      )}
    </>
  );
};

export default ContactoAsociado;
